import { apiGET, apiPOST, apiPUT, apiPATCH } from "./handler";
import API from "./axios";

// Invoice APIs
export const getInvoices = (params) => 
  apiGET("/litigation/api/invoices/", params);

export const getLitigationInvoices = (params) =>
  apiGET("/litigation/api/litigation-invoices/", params);

export const getInvoiceDetail = (id) => 
  apiGET(`/litigation/api/invoices/${id}/`, {});

export const createInvoice = (body) => 
  apiPOST("/litigation/api/invoices/", body);

export const updateInvoice = (id, body) => 
  apiPUT(`/litigation/api/invoices/${id}/`, body);

export const patchInvoice = (id, body) => 
  apiPATCH(`/litigation/api/invoices/${id}/`, body);

export const deleteInvoice = (id) => 
  API.delete(`/litigation/api/invoices/${id}/`);

export const markInvoiceAsPaid = (id) => 
  apiPATCH(`/litigation/api/invoices/${id}/`, { invoice_status: "paid" });

export const cancelInvoice = (id) => 
  apiPATCH(`/litigation/api/invoices/${id}/`, { invoice_status: "cancelled" });

export const sendInvoiceEmail = (id, body) => 
  apiPOST(`/litigation/api/invoices/${id}/send_email/`, body);

export const sendLitigationInvoiceEmail = (id) =>
  apiGET("/litigation/api/send-litigation-invoice-email/", { id });

export const sendLitigationInvoiceFollowupEmail = (id) =>
  apiGET("/litigation/api/invoice_followup_email/", { id });

export const regenerateInvoice = (id) => 
  apiPOST(`/litigation/api/invoices/${id}/regenerate/`, {});

export const downloadInvoicePDF = (id) => 
  API.get(`/litigation/api/invoices/${id}/pdf/`, {
    responseType: "blob"
  });

export const generateLitigationInvoices = ({ client_id, id }) => 
  apiGET("/litigation/api/generate-litigation-invoices/", {
    client_id,
    id,
  });

export const updateLitigationInvoice = (body) =>
  apiPOST("/litigation/api/litigation-invoices/", body);

// Client APIs
export const getClients = (params) => 
  apiGET("/litigation/api/clients/", params);

export const getClientDetail = (id) => 
  apiGET(`/litigation/api/clients/${id}/`, {});

export const createClient = (body) => 
  apiPOST("/litigation/api/clients/", body);

export const updateClient = (id, body) => 
  apiPUT(`/litigation/api/clients/${id}/`, body);

export const deleteClient = (id) => 
  API.delete(`/litigation/api/clients/${id}/`);
